module.exports = __webpack_public_path__ + "static/media/post-mindfulness.1019d41f.svg";